import { aFPCreateAttachmentHandler } from 'owa-mail-compose-view-shared/lib/utils/createAttachmentHandler';
import { upsellAndInsertLinks } from './upsellAndInsertLinks';
import type AttachmentMultiPicker from 'owa-attachment-filepicker/lib/types/AttachmentMultiPicker';
import CreateAttachmentHandlers from '../types/CreateAttachmentHandlers';
import { getInsertLinksHost } from 'owa-mail-compose-view-shared/lib/utils/getInsertLinksHost';
import type { AttachmentMultiMenuEntry } from 'owa-attachment-multi-menu-actions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyInsertLinks } from 'owa-insert-link';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';
import getComposeUniqueState from 'owa-mail-compose-actions/lib/utils/getComposeUniqueState';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { lazyGetShouldShareAttachmentProperties } from 'owa-attachment-well-data';

// Null handler for when there is no compose viewstate
function nullAttachmentHandler(): void {}

export function getCreateAttachmentHandlers(
    attachmentPickers: AttachmentMultiPicker,
    attachmentMultiMenuEntry: AttachmentMultiMenuEntry,
    viewState: ComposeViewState | undefined
): CreateAttachmentHandlers {
    const handlers: CreateAttachmentHandlers = {
        computer: viewState
            ? attachmentMultiMenuEntry.computer.getCreateAttachmentHandler(
                  viewState.attachmentWell,
                  (files, properties, dataProvider) => {
                      // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                      // -> Error TS2345 (30,80): Argument of type 'AttachmentDataProviderType | null' is not assignable to parameter of type 'AttachmentDataProviderType'.
                      // @ts-expect-error
                      aFPCreateAttachmentHandler(files, viewState, properties, dataProvider);
                  },
                  getComposeUniqueState(viewState),
                  attachmentPickers.targetWindow,
                  async params => {
                      const insertLinks = await lazyInsertLinks.import();
                      const getShouldShareAttachmentProperties = await lazyGetShouldShareAttachmentProperties.import();
                      insertLinks(
                          params.files,
                          getInsertLinksHost(viewState),
                          viewState,
                          getCurrentFromAddress(viewState.toRecipientWell),
                          attachmentPickers.targetWindow,
                          viewState.linksContainerId,
                          // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                          // -> Error TS2345 (47,27): Argument of type 'null' is not assignable to parameter of type 'string | undefined'.
                          // @ts-expect-error
                          null /* selectionText */,
                          // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                          // -> Error TS2345 (51,62): Argument of type 'CreateAttachmentsProperties | null' is not assignable to parameter of type 'CreateAttachmentsProperties'.
                          // @ts-expect-error
                          getShouldShareAttachmentProperties(params.properties)
                      );
                  },
                  isFeatureEnabled('doc-deprecateCloudy-preview') ||
                      isFeatureEnabled('doc-deprecateCloudy-preview-thumbnailView')
              )
            : nullAttachmentHandler,

        uploadAndLinkFromCloud: viewState
            ? attachmentMultiMenuEntry.uploadAndShareFromCloud.getCreateAttachmentHandler(
                  viewState.attachmentWell,
                  (files, properties, dataProvider) =>
                      upsellAndInsertLinks(
                          files,
                          viewState,
                          properties,
                          // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                          // -> Error TS2345 (70,27): Argument of type 'AttachmentDataProviderType | null' is not assignable to parameter of type 'AttachmentDataProviderType'.
                          // @ts-expect-error
                          dataProvider,
                          attachmentPickers.targetWindow
                      ),
                  getComposeUniqueState(viewState),
                  attachmentPickers.targetWindow
              )
            : nullAttachmentHandler,

        uploadAndShareFromCloud: viewState
            ? attachmentMultiMenuEntry.uploadAndShareFromCloud.getCreateAttachmentHandler(
                  viewState.attachmentWell,
                  (files, properties, dataProvider) =>
                      // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                      // -> Error TS2345 (85,80): Argument of type 'AttachmentDataProviderType | null' is not assignable to parameter of type 'AttachmentDataProviderType'.
                      // @ts-expect-error
                      aFPCreateAttachmentHandler(files, viewState, properties, dataProvider),
                  getComposeUniqueState(viewState),
                  attachmentPickers.targetWindow
              )
            : nullAttachmentHandler,
    };

    return handlers;
}
